export default __webpack_public_path__ + "static/media/polygon.e519d849.svg";